import { AnalyticsEvent } from "./analyticsEvent"
class AccordionInteractionEvent extends AnalyticsEvent {
    public sectionTitle: string;
    public sectionIndex: number;
    public interaction: string;
    public accordionLocation: string;
    constructor(sectionTitle: string, sectionIndex: number, interaction: string, location: string) {
        super();
        this.sectionTitle = sectionTitle;
        this.sectionIndex = sectionIndex;
        this.interaction = interaction;
        this.accordionLocation = location;
    }
}
export { AccordionInteractionEvent }